import React from 'react';

const Tool3Page = () => (
  <div style={{ maxWidth: 600, margin: '40px auto', padding: 24 }}>
    <h2>Tool 3 Page</h2>
    <p>This is Tool 3. Add your tool functionality here.</p>
  </div>
);

export default Tool3Page;
